import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import Button from './Button';

const ErrorModal = ({ error }) => {
  const [show, setShow] = useState();

  useEffect(() => {
    if (error) {
      setShow(true);
    }
  }, [error]);

  const handleClose = () => {
    setShow(false);
  };

  const title = 'Något gick fel';
  const text =
    ' Om problemet skulle kvarstå, var god kontakta oss på kontakt@kthbok.com';
  const buttonText = 'Stäng';

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{text}</Modal.Body>
      <Modal.Footer>
        <Button backgroundColor="primaryColor" onClick={handleClose}>
          {buttonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;
